import { CommentStatus } from '../../types';
import { Badge, Avatar } from '../../widgets';
import { defaultAuth } from '../../atoms/auth';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { IQuestionList } from '../../inter/list';
import { TargetItem, ActionType } from '../../types';
import { TrashIcon, ReplyIcon } from '@heroicons/react/outline';
dayjs.extend(utc);
dayjs.extend(timezone);

const Item = ({
  props,
  target,
  action,
}: {
  props: IQuestionList;
  target: TargetItem;
  action(
    type: ActionType,
    item: { id: string; target?: Omit<TargetItem, '_id' | 'product_id'> },
  ): void;
}): JSX.Element => {
  return (
    <div className="bg-white flex justify-between items-center rounded-md shadow-xs">
      <div className="px-4 py-4 text-left w-[400px] sm:w-[400px] lg:w-[500px] xl:w-[600px] 2xl:w-[800px]">
        <div className="flex space-x-3 items-start">
          <div className="w-10 h-10">
            <Avatar title={props.customer.name} />
          </div>
          <div className="flex flex-1 flex-col space-y-1">
            <div className="space-x-2 flex justify-between items-center">
              <span className="font-medium text-gray-900 text-sm">
                {props.customer.name}
              </span>
              <span className="text-gray-500 text-xs">
                {dayjs.utc(props.createdAt).format('DD/MM/YYYY HH:mm')}
              </span>
            </div>
            <p
              className="text-gray-700 text-sm line-clamp-2"
              title={props.desc}
            >
              {props.desc}
            </p>
            <div className="flex items-start space-x-1">
              <span className="w-4 h-4 flex">
                <ReplyIcon className="w-full h-full rotate-180 text-gray-400" />
              </span>
              <a
                href={`${defaultAuth?.myharavan_domain}/products/${target.handle}`}
                target="_blank"
                rel="noreferrer"
                className="text-sm line-clamp-2 text-blue-700"
                title={target.title}
              >
                {target.title}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="w-[100px] px-2 py-4 flex justify-center">
        <Badge status={props.status} />
      </div>
      <div className="w-[80px] px-2 py-4 flex flex-col justify-center items-center">
        <span className="text-xs text-gray-700 font-medium">
          {props.upvoteCount}
        </span>
      </div>
      <div className="w-[80px] px-2 py-4 flex flex-col justify-center items-center">
        {props._count.replies > 0 ? (
          <span className="text-xs text-gray-700 font-medium">
            {props._count.replies} trả lời
          </span>
        ) : (
          <span className="text-xs text-gray-500">Không có</span>
        )}
      </div>
      <div className="whitespace-nowrap flex-1 px-2 py-4 pr-4 space-x-3 flex justify-end items-center">
        {props.status === CommentStatus.pending ? (
          <button
            type="button"
            className="h-6 bg-green-50 text-green-600 hover:bg-green-100 text-xs font-medium px-2 py-1 rounded-md"
            onClick={() => {
              action(ActionType.approve, { id: props.id });
            }}
          >
            Duyệt
          </button>
        ) : null}
        <button
          type="button"
          className="h-6 bg-pink-50 text-pink-600 hover:bg-pink-100 text-xs font-medium px-2 py-1 rounded-md"
          onClick={() => {
            action(ActionType.reply, {
              id: props.id,
              target: {
                title: target.title,
                handle: target.handle,
              },
            });
          }}
        >
          Trả lời
        </button>
        <button
          type="button"
          className="h-6 bg-indigo-50 text-indigo-600 hover:bg-indigo-100 text-xs font-medium px-2 py-1 rounded-md"
          onClick={() => {
            action(ActionType.edit, {
              id: props.id,
              target: {
                title: target.title,
                handle: target.handle,
              },
            });
          }}
        >
          Chỉnh sửa
        </button>
        <button
          type="button"
          title="Xoá trả lời"
          className="w-6 h-6 inline-flex justify-center items-center bg-red-50 text-red-600 hover:bg-red-100 rounded-md"
          onClick={() => {
            action(ActionType.delete, { id: props.id });
          }}
        >
          <TrashIcon className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Item;
